(() => {
  // ===== config =====
  const LOW_BRIDGE_FIT = new Set(['RW4013F', 'RW4009F']);
  const NOT_LOW_BRIDGE_FIT = new Set(['RW4009','RB2132','RB2140','RB3025','RW4013']);
  const CUSTOM_PRODUCT_TITLE = 'custom sunglass replacement lens';

  // ===== modal =====
  function injectModal() {
    if (document.getElementById('model-check-modal')) return;
    document.body.insertAdjacentHTML('beforeend', `
      <div id="model-check-modal" style="position:fixed;inset:0;display:none;z-index:99999">
        <div style="position:absolute;inset:0;background:rgba(0,0,0,.45)"></div>
        <div style="position:relative;max-width:560px;width:calc(100% - 20px);margin:8vh auto;background:#fff;border-radius:14px;overflow:hidden;box-shadow:0 10px 30px rgba(0,0,0,.2);box-sizing:border-box;">
          <div style="padding:22px 22px 8px">
            <h3 id="model-check-title" style="margin:0 0 10px;font-size:20px;line-height:1.3">Confirm Your Frame Model</h3>

            <img id="model-check-image"
                 src="https://cdn.shopify.com/s/files/1/0256/6370/1058/files/model-number.webp?v=1756145404"
                 alt="Where to find the frame number on the arm" loading="lazy"
                 style="width:100%;height:auto;display:block;border-radius:10px;margin:8px 0 12px;object-fit:contain;" />

            <div id="model-check-message" style="margin:0 0 12px;color:#333"></div>

            <label id="model-check-confirm-wrap" style="display:flex;gap:8px;align-items:flex-start;margin:10px 0 6px;cursor:pointer">
              <input id="model-check-confirm" type="checkbox" style="margin-top:3px">
              <span id="model-check-label">I confirm the model(s) and lens size(s) are correct.</span>
            </label>

            <div style="display:flex;gap:10px;justify-content:flex-end;padding-top:12px">
              <button id="model-check-close" style="padding:10px 14px;border:1px solid #ddd;background:#fff;border-radius:10px;cursor:pointer">Close</button>
              <button id="model-check-continue" style="padding:10px 14px;background:#111;color:#fff;border:none;border-radius:10px;cursor:pointer;opacity:.6" disabled>Continue</button>
            </div>

            <div id="model-check-footnote" style="font-size:12px;color:#666;margin-top:10px">
              The frame number is printed on the inside of the frame arm.
            </div>
          </div>
        </div>
      </div>
    `);

    const modal   = document.getElementById('model-check-modal');
    const confirm = document.getElementById('model-check-confirm');
    const closeBtn= document.getElementById('model-check-close');
    const contBtn = document.getElementById('model-check-continue');

    confirm.onchange = () => {
      contBtn.disabled = !confirm.checked;
      contBtn.style.opacity = confirm.checked ? '1' : '.6';
    };

    closeBtn.onclick = () => {
      modal.style.display = 'none';
      document.body.style.overflow = '';
    };

    contBtn.onclick = () => {
      if (!confirm.checked) return;
      advancePopupQueue();
    };
  }

  // ===== cart helpers =====
  async function getCart() {
    try { const r = await fetch('/cart.js', { credentials:'same-origin' }); return r.ok ? r.json() : { items: [] }; }
    catch { return { items: [] }; }
  }

  function isCustomProduct(item) {
    return (item.title || '').toLowerCase().includes(CUSTOM_PRODUCT_TITLE);
  }

  function isRayBanOrHasCode(item) {
    const t = (item.title || '').toLowerCase();
    const v = (item.vendor || '').toLowerCase();
    return v.includes('ray-ban') || t.includes('ray-ban') || !!getModelCode(item);
  }

  function getModelCode(item) {
    const extract = (str) => {
      if (!str) return null;
      const m = String(str).match(/\b(RB|RW)\s*-?\s*(\d{3,5})\s*([A-Z])?\b/i);
      if (!m) return null;
      return (m[1].toUpperCase() + m[2] + (m[3] ? m[3].toUpperCase() : ''));
    };

    if (item.properties) {
      const fromProp = extract(item.properties._model_code || item.properties.model_code || item.properties.Model || item.properties['Model Code']);
      if (fromProp) return fromProp;
    }
    if (Array.isArray(item.options_with_values)) {
      for (const o of item.options_with_values) {
        const v1 = extract(o.value); if (v1) return v1;
        const v2 = extract(o.name);  if (v2) return v2;
      }
    }
    const vt = extract(item.variant_title); if (vt) return vt;
    if (Array.isArray(item.variant_options)) {
      for (const opt of item.variant_options) { const v = extract(opt); if (v) return v; }
    }
    return extract(item.title) || extract(item.sku) || null;
  }

  function getLensSize(item) {
    const m = (item.variant_title || '').match(/(\d{2,3})\s*mm/i);
    return m ? `${m[1]}mm` : 'selected';
  }

  function gatherItems(items) {
    const out = [];
    (items || []).forEach(i => {
      if (!isRayBanOrHasCode(i)) return;
      const code = getModelCode(i);
      if (!code) return;
      out.push({ code, size: getLensSize(i) });
    });
    return out;
  }

  // ===== ray-ban messaging =====
  const dedupe = (arr) => {
    const seen = new Set(), res = [];
    arr.forEach(x => { const key = `${x.code}|${x.size}`; if (!seen.has(key)) { seen.add(key); res.push(x); } });
    return res;
  };

  function categorize(code) {
    if (LOW_BRIDGE_FIT.has(code)) return 'LBF';
    if (NOT_LOW_BRIDGE_FIT.has(code)) return 'NOT_LBF';
    return 'GENERAL';
  }

  function buildMessage(items) {
    const unique = dedupe(items);
    const parts = unique.map(({code, size}) => {
      const tag = `<strong>${code} | ${size}</strong>`;
      const cat = categorize(code);
      if (cat === 'LBF') return `You have ${tag} in your cart. This is the Low-Bridge Fit version. Please confirm the model and lens size.`;
      if (cat === 'NOT_LBF') return `You have ${tag} in your cart. This model is not Low-Bridge Fit. Please confirm the model and lens size.`;
      return `You have ${tag} in your cart. Please confirm the model and lens size.`;
    });

    return {
      html: parts.map(p => `<p style="margin:0 0 10px">${p}</p>`).join(''),
      label: 'I confirm the model(s) and lens size(s) are correct.'
    };
  }

  // ===== popup queue =====
  let popupQueue = [];
  let activeDrawerRef = null;

  function resetConfirmState() {
    const confirm = document.getElementById('model-check-confirm');
    const contBtn = document.getElementById('model-check-continue');
    confirm.checked = false;
    contBtn.disabled = true;
    contBtn.style.opacity = '.6';
  }

  function showCustomPopup() {
    injectModal();

    document.getElementById('model-check-title').textContent = '';
    document.getElementById('model-check-image').style.display = 'none';
    document.getElementById('model-check-footnote').textContent = '';

    document.getElementById('model-check-message').innerHTML = `
      <p style="margin:0 0 10px"><strong>Action Needed After Checkout</strong></p>
      <p style="margin:0 0 10px">
        Please email a photo of your sunglass frames to <strong>vip@lifeartvision.com</strong>.
      </p>
      <p style="margin:0">
        If your frame has a model number printed inside the arm, include that too. This helps us custom cut your replacement lenses to the correct shape and size.
      </p>
    `;

    document.getElementById('model-check-label').textContent =
      'I understand I need to email a photo of my frames after checkout.';

    resetConfirmState();
    openModal();
  }

  function showRayBanPopup(rbItems) {
    injectModal();

    document.getElementById('model-check-title').textContent = 'Confirm Your Frame Model';
    document.getElementById('model-check-image').style.display = 'block';
    document.getElementById('model-check-footnote').textContent =
      'The frame number is printed on the inside of the frame arm.';

    const { html, label } = buildMessage(rbItems);
    document.getElementById('model-check-message').innerHTML = html;
    document.getElementById('model-check-label').textContent = label;

    resetConfirmState();
    openModal();
  }

  function openModal() {
    document.getElementById('model-check-modal').style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  function closeModalOnly() {
    document.getElementById('model-check-modal').style.display = 'none';
    document.body.style.overflow = '';
  }

  function showNextPopupFromQueue() {
    if (!popupQueue.length) return;
    const next = popupQueue[0];
    if (next.type === 'CUSTOM') showCustomPopup();
    if (next.type === 'RB') showRayBanPopup(next.rbItems);
  }

  function advancePopupQueue() {
    popupQueue.shift();
    if (popupQueue.length) {
      showNextPopupFromQueue();
    } else {
      unlockCheckoutInDrawer(activeDrawerRef);
      closeModalOnly();
    }
  }

  // ===== checkout locking =====
  function getDrawerCheckoutTargets(drawer) {
    const buttons = Array.from(drawer.querySelectorAll('button[name="checkout"]'));
    const forms   = Array.from(drawer.querySelectorAll('form[action*="/cart"]'));
    const links   = Array.from(drawer.querySelectorAll('a[href*="/checkout"]'));
    return { buttons, forms, links };
  }

  function lockCheckoutInDrawer(drawer) {
    if (!drawer) return;
    const { buttons, forms, links } = getDrawerCheckoutTargets(drawer);
    buttons.forEach(b => b.disabled = true);
    forms.forEach(f => f.addEventListener('submit', e => e.preventDefault(), true));
    links.forEach(a => a.addEventListener('click', e => e.preventDefault(), true));
  }

  function unlockCheckoutInDrawer(drawer) {
    if (!drawer) return;
    const { buttons } = getDrawerCheckoutTargets(drawer);
    buttons.forEach(b => b.disabled = false);
  }

  // ===== drawer observer =====
  function setupDrawerObserver(drawer) {
    let gatedThisOpen = false;

    const ob = new MutationObserver(async () => {
      const open = drawer.classList.contains('active');
      if (open && !gatedThisOpen) {
        const cart = await getCart();
        const items = cart.items || [];

        const hasCustom = items.some(isCustomProduct);
        const rbItems = gatherItems(items);

        if (!hasCustom && !rbItems.length) return;

        popupQueue = [];
        if (hasCustom) popupQueue.push({ type: 'CUSTOM' });
        if (rbItems.length) popupQueue.push({ type: 'RB', rbItems });

        activeDrawerRef = drawer;
        lockCheckoutInDrawer(drawer);
        showNextPopupFromQueue();

        gatedThisOpen = true;
      }

      if (!open) {
        gatedThisOpen = false;
        popupQueue = [];
        activeDrawerRef = null;
        unlockCheckoutInDrawer(drawer);
        closeModalOnly();
      }
    });

    ob.observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }

  function init() {
    const sel = 'cart-drawer#Cart-Drawer, #Cart-Drawer';
    let drawer = document.querySelector(sel);
    if (drawer) { setupDrawerObserver(drawer); return; }
    const wait = new MutationObserver(() => {
      drawer = document.querySelector(sel);
      if (drawer) { wait.disconnect(); setupDrawerObserver(drawer); }
    });
    wait.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
